// Adapted from https://learn.microsoft.com/en-us/javascript/api/office/office.document?view=common-js-preview#office-office-document-getfileasync-member(1)

import { ExcelFileExtension } from "./excelFileUtils";

let sliceIndex: number;
let docDataSlices: any[];
let file: Office.File;

export function getFileExtension(
  onGetFileExtension: (fileExtension: ExcelFileExtension) => void,
  onInvalidFileExtension: () => void
) {
  Office.context.document.getFilePropertiesAsync(function (result) {
    if (result.status === Office.AsyncResultStatus.Succeeded) {
      const fileUrl = result.value.url;
      const fileExtension = `.${fileUrl.split(".").pop()}`;
      if ((Object.values(ExcelFileExtension) as string[]).includes(fileExtension)) {
        onGetFileExtension(fileExtension as ExcelFileExtension);
      } else {
        onInvalidFileExtension();
      }
    } else {
      onInvalidFileExtension();
    }
  });
}

export function getCurrentFileAndUpload(
  upload: (file: Uint8Array) => void,
  setUploadProgressValue: (progress: number) => void, // Representing a progress value from 0 to 100
  onUploadError: () => void
) {
  Office.context.document.getFileAsync(Office.FileType.Compressed, function (result: Office.AsyncResult<Office.File>) {
    if (result.status === Office.AsyncResultStatus.Succeeded) {
      // If the getFileAsync call succeeded, then
      // result.value will return a valid File Object.
      file = result.value;
      sliceIndex = 0;
      docDataSlices = [];

      // Get the file slices.
      getSliceAsync(upload, setUploadProgressValue, onUploadError);
    } else {
      onUploadError();
    }
  });
}

function getSliceAsync(
  upload: (file: Uint8Array) => void,
  setUploadProgressValue: (progress: number) => void,
  onUploadError: () => void
) {
  file.getSliceAsync(sliceIndex, function (sliceResult: Office.AsyncResult<Office.Slice>) {
    if (sliceResult.status === Office.AsyncResultStatus.Succeeded) {
      // Got one slice, store it in a temporary array.
      docDataSlices[sliceResult.value.index] = sliceResult.value.data;
      sliceIndex++;

      setUploadProgressValue(getProgress());

      if (sliceIndex === file.sliceCount) {
        // All slices have been received.
        onGotAllSlices(upload);
        file.closeAsync();
      } else {
        getSliceAsync(upload, setUploadProgressValue, onUploadError);
      }
    } else {
      onUploadError();
      file.closeAsync();
    }
  });
}

function onGotAllSlices(upload: (file: Uint8Array) => void) {
  let docData = [];
  for (let i = 0; i < docDataSlices.length; i++) {
    docData = docData.concat(docDataSlices[i]);
  }

  upload(new Uint8Array(docData));
}

function getProgress() {
  // Reserve the first 50 percent for getting the slices, and the second half for uploading to S3
  return (sliceIndex / file.sliceCount / 2) * 100;
}
